/**
 * @description Masters Store Module
 * @author Fahid Mohammad
 */
export default {
    namespaced: true,
    state: {
        getEmpData: null,
        getFormData:null
    },
    mutations: {
        SET_EMP_DATA: (state, data) => {
            state.getEmpData = data;
        },
        SET_FORM_DATA: (state, data) => {
            state.getFormData = data;
        },
    },
    actions: {
        SET_EMP_DATA({commit}, data) {
            commit('SET_EMP_DATA', data)
        },
        SET_FORM_DATA({commit}, data) {
            commit('SET_FORM_DATA', data)
        },
    },
    getters: {
        getEmpData: state => { return state.getEmpData},
        getFormData: state => { return state.getFormData},

    }
}




// WEBPACK FOOTER //
// ./src/store/modules/hospemployee.js